import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const CircleFilled: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path
      clipRule="evenodd"
      d="M10 18.3333C5.40002 18.3333 1.66669 14.6 1.66669 9.99998C1.66669 5.39998 5.40002 1.66665 10 1.66665C14.6 1.66665 18.3334 5.39998 18.3334 9.99998C18.3334 14.6 14.6 18.3333 10 18.3333Z"
      fillRule="evenodd"
    />
  </CustomIcon>
);

export default CircleFilled;
